import PropTypes from "prop-types"

import "./service_brand.scss"

export default function ServiceBrand({ description, image, title }) {
  return (
    <>
      <img
        title={title}
        alt={title}
        styleName="service-brand"
        width="120"
        height="120"
        src={image}
      />
      <h1
        styleName="brand-title"
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      {description && <p styleName="brand-description">{description}</p>}
    </>
  )
}

ServiceBrand.propTypes = {
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
